// extracted by mini-css-extract-plugin
export default {"wrap":"dr-z","logoContainer":"er-z","brandImg":"fr-z","logoImg":"gr-z","logoButton":"hr-z"};